"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * External Dependencies
 */
require("jquery");
require("../../node_modules/bootstrap/js/dist/dropdown");
var mmenu_light_1 = require("mmenu-light");
var utils_1 = require("./utils");
if ((0, utils_1.exist)('#primary_navigation--js')) {
    var menuEl = (0, utils_1.select)('#primary_navigation--js');
    var Menu = new mmenu_light_1.default(menuEl, '(max-width: 991px)', 'dark');
    var navigator = Menu.navigation({ // selectedClass: 'Selected',
    // slidingSubmenus: true,
    // theme: 'dark',
    // title: 'Menu'
    });
    var drawerMenu = Menu.offcanvas({
        position: 'left',
        title: 'Menu'
    });
    if ((0, utils_1.exist)('.navbar-toggler')) {
        var menuToggler = (0, utils_1.select)('.navbar-toggler');
        menuToggler.addEventListener('click', function (e) {
            e.preventDefault();
            drawerMenu.open();
        });
    }
}
if ((0, utils_1.exist)('.single_add_to_cart_button:not(.custom_link)')) {
    var uppdate_btn_price = function uppdate_btn_price(price) {
        add_to_cart.textContent = 'Add to cart | $' + price;
    };
    var qty_input = (0, utils_1.select)('.input-text.qty.text');
    var add_to_cart = (0, utils_1.select)('.single_add_to_cart_button.button');
    var price = (0, utils_1.select)('.single-product-price');
    var price_c = price.getAttribute('data-price');
    qty_input.value = 1;
    setTimeout(function () {
        if ((0, utils_1.exist)('.custom-btns-qty .minus') && (0, utils_1.exist)('.custom-btns-qty .plus')) {
            var minus = (0, utils_1.select)('.custom-btns-qty .minus');
            var plus = (0, utils_1.select)('.custom-btns-qty .plus');
            minus.addEventListener('click', function () {
                if (qty_input.value != qty_input.getAttribute('min')) {
                    var m = Number(qty_input.value) - 1;
                    uppdate_btn_price(price_c * m);
                }
            });
            plus.addEventListener('click', function () {
                var m = Number(qty_input.value) + 1;
                uppdate_btn_price(price_c * m);
            });
        }
    }, 1500);
    uppdate_btn_price(price_c);
}
